import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import AdminInstructionForm from './AdminInstructionForm';

export default function AdminInstructionEdit(props) {
    const [instruction, setInstruction] = useState(null);
    const [sections, setSections] = useState(null);
    const [sectionId, setSectionId] = useState(null);
    const [fetchedSections, setFetchedSections] = useState(false);

    useEffect(() => {
        axios
            .untranslated()
            .get(props.fetchUrl)
            .then((response) => {
                setSectionId(response.data.instruction.section_id);
                setInstruction(response.data.instruction);
                setSections(response.data.sections);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, []);

    useEffect(() => {
        if (sections) {
            setFetchedSections(true);
        }
    }, [sections]);

    return (
        <div>
            {instruction && fetchedSections && (
                <AdminInstructionForm
                    uploadUrl={props.uploadUrl}
                    saveUrl={props.saveUrl}
                    section={instruction.section || ''}
                    content={instruction.content || ''}
                    order={instruction.order || 0}
                    sections={sections}
                    sectionId={sectionId}
                />
            )}
        </div>
    );
}

if (document.getElementById('edit-user-guide-admin')) {
    ReactDOM.render(
        <App>
            <AdminInstructionEdit fetchUrl={fetchUrl} saveUrl={saveUrl} uploadUrl={uploadUrl} />
        </App>,
        document.getElementById('edit-user-guide-admin'),
    );
}
